import type { SanityDocumentFootnotes } from '#/lib/sanity/queries/footnotes';
import { cn } from '#/lib/utils';
import { FormattedText } from '#/components/FormattedText';

const THEME_CLASSES: Record<SanityDocumentFootnotes['theme'], string> = {
  light: 'bg-grayscale-01 text-grayscale-05',
  charcoal: 'bg-charcoal text-grayscale-04',
  purple: 'bg-cipher text-cloud',
};

export function Footnotes({ theme, content }: SanityDocumentFootnotes) {
  if (!content?.length) return null;

  return (
    <div className={cn('py-40', THEME_CLASSES[theme] ?? THEME_CLASSES.light)}>
      <div className="px-15 l:px-25">
        <div className="px-22 l:px-45">
          <FormattedText
            value={content}
            className="type-paragraph-xs gap-[1em] italic [&_a]:underline [&_a]:decoration-from-font [&_a]:underline-offset-1"
          />
        </div>
      </div>
    </div>
  );
}
